import React, { useEffect, useState } from 'react';
import { Task, TaskResponse, TaskState } from 'gql/graphql';
import { CardLoanTasksProps } from 'components/Atoms/Cards/CardLoanTasks/CardLoanTasks';
import Payoff from './Payoff';
import { ModuleKeys } from 'services/task/modules-keys.constanst';
import CircleTag from '../../../../../components/Atoms/Tags/CircleTag/CircleTag';

interface Props {
  tasks?: Task[] | any[],
}

const useCardPayoff = ({ tasks }: Props) => {
  const [dataTask, setDataTask] = useState<Task>();
  const [stepNow, setStepNow] = useState<TaskResponse>();
  const [response, setResponse] = useState<TaskResponse>();
  const [step1, setStep1] = useState<TaskResponse>();

  useEffect(() => {
    if (tasks) {
      const data: Task = tasks.find((item) => item.key === ModuleKeys.PAYOFF);
      setDataTask(data);
      setStep1(data?.responses.find(item => item.step === 1))
      setResponse(data?.responses.find(item => item.step === 2));

      if (data?.responses.length > 0)
        setStepNow(data?.responses.reduce((max, obj) => obj.step > max.step ? obj : max, data?.responses[0]));
    }
  }, [tasks]);

  const getTotalApproved = () => {
    const isFileSubmitted = response?.files?.filter(item => item.state !== 'request_error') || [];
    const otherDocIsSubmitted = dataTask?.responses?.filter(item => item.key === 'doc-another' && item.state !== TaskState.RequestError) || [];
    return isFileSubmitted.length > 0 && otherDocIsSubmitted.length === 0 ? 1
      : isFileSubmitted.length > 0 && otherDocIsSubmitted.length > 0 ? 2 :
        isFileSubmitted.length === 0 && otherDocIsSubmitted.length > 0 ? otherDocIsSubmitted.length : 0;
  }

  const generateCirclesFooter: any = () => {
    const addAnotherDocs = dataTask?.responses?.filter(item => item.key === 'doc-another');

    const docs = addAnotherDocs?.map(item =>
      ({ state: item.state, name: item.label })
    ) || [];
    return docs;
  };

  const getFilesCircle = () => {
    const filesWithoutError = response?.files?.filter((item: any) => item.state !== 'request_error') || [];
    
    if (filesWithoutError.length > 0) {
      return [filesWithoutError[filesWithoutError.length - 1]];
    }
    
    const lastFile = response?.files?.slice(-1)[0];
    return lastFile ? [lastFile] : [{ state: 'DRAFT' }];
  }

  const card: CardLoanTasksProps =
  {
    key: ModuleKeys.PAYOFF,
    title: <h4 className="h4">Payoff</h4>,
    steps: 2,
    stepCurrent: stepNow?.step || 0,
    type: 'quick task',
    state: dataTask?.state,
    actions: dataTask ? [<Payoff key={1} task={dataTask} />] : [],
    text: (
      <p className="body-card">
        {dataTask?.state === TaskState.Draft ? 'Letter/contact is not submitted' : (
          <>
            My payoff contact is{' '}
            <span className="body-card-bold-line">
              {step1?.key === 'yes' ? response && response?.files?.length ? 'letter is submitted' :
                'letter is not submitted' : response && response.metadata?.email ? 'contact is submitted' :
                'contact is not submitted'}
            </span>
          </>
        )}
      </p>
    ),
    text2: !step1 || (step1?.key === 'no' && generateCirclesFooter().length === 0) ? null : (
      <div className='docs-section'>
        <div className='labels'>
          <p className={`body-regular body-regular-bold`}>
            Document status
          </p>
          <p className={`body-card`}>
            {getTotalApproved()}/{
              step1?.key === 'yes'
                ? (generateCirclesFooter()?.length || 0) + 1
                : generateCirclesFooter()?.length || 0
            } submitted
          </p>
        </div>
        <div className={`circles-tags`}>
          {step1?.key === 'yes' && getFilesCircle().map((_response, index) => {
            let _state = _response?.state.toUpperCase() || 'DRAFT';

            return (<CircleTag
              key={index}
              state={_state}
              tagKey={_state}
              isIconState={true}
            />);
          })}
          {generateCirclesFooter().map((item: any, index: number) => {
            let _state = item.state || 'DRAFT';

            return (<CircleTag
              key={index}
              state={_state}
              tagKey={_state}
              isIconState={true}
            />);
          })}
        </div>
      </div>
    )
  };

  if (!dataTask)
    return { card: null };

  return {
    card,
    dataTask
  };
};

export default useCardPayoff;